'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _AllSubstringsIndexStrategy = require('./AllSubstringsIndexStrategy');

Object.defineProperty(exports, 'AllSubstringsIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _AllSubstringsIndexStrategy.AllSubstringsIndexStrategy;
  }
});

var _ExactWordIndexStrategy = require('./ExactWordIndexStrategy');

Object.defineProperty(exports, 'ExactWordIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _ExactWordIndexStrategy.ExactWordIndexStrategy;
  }
});

var _PrefixIndexStrategy = require('./PrefixIndexStrategy');

Object.defineProperty(exports, 'PrefixIndexStrategy', {
  enumerable: true,
  get: function get() {
    return _PrefixIndexStrategy.PrefixIndexStrategy;
  }
});
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ./~/js-search/dist/commonjs/IndexStrategy/index.js
// module id = 347
// module chunks = 0